import type { Rarity } from '__generated__/globalTypes';
import { unitMapping } from 'lib/style';
import { toSnakeCase } from 'lib/toSnakeCase';

type Props = {
  rarity: Rarity;
  size?: keyof typeof unitMapping;
  lightened?: boolean;
};

export const BoxStar = ({ rarity, size = 2, lightened }: Props) => {
  const fill = `url(#svg-${toSnakeCase(rarity.toLowerCase())}-gradient)`;

  return (
    <svg
      viewBox="0 0 12 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: unitMapping[size], height: unitMapping[size] }}
    >
      <path
        d="M6 0L8.01023 3.23316L11.7063 4.1459L9.25261 7.05684L9.52671 10.8541L6 9.42L2.47329 10.8541L2.74739 7.05684L0.293661 4.1459L3.98977 3.23316L6 0Z"
        fill={fill}
        fillOpacity={lightened ? 1 : 0.3}
      />
    </svg>
  );
};
